import { render, staticRenderFns } from "./VIPRefund.vue?vue&type=template&id=1b89e13f&scoped=true&"
import script from "./VIPRefund.vue?vue&type=script&lang=js&"
export * from "./VIPRefund.vue?vue&type=script&lang=js&"
import style0 from "./VIPRefund.vue?vue&type=style&index=0&id=1b89e13f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b89e13f",
  null
  
)

export default component.exports